module.exports = __webpack_public_path__ + "images/icons/paid-boat-icon.svg";